export default function goToResult() {
  const pageResultsContainer = document.getElementById("page-results");
  pageResultsContainer.scrollIntoView();
}
